import { useSyncExternalStore } from 'react';
import { api, type SessionState } from './api';

export function useSession(): SessionState {
  // The same snapshot when a page is drawn to HTML (the tests of the pages' words do).
  return useSyncExternalStore(api.subscribe, api.getState, api.getState);
}

/** A minimal observable store for state that lives outside React (the call). */
export class Store<T> {
  private readonly listeners = new Set<() => void>();

  constructor(protected state: T) {}

  getState = (): T => this.state;

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  protected set(patch: Partial<T>): void {
    this.state = { ...this.state, ...patch };
    for (const l of this.listeners) l();
  }
}

export function useStore<T>(store: Store<T>): T {
  return useSyncExternalStore(store.subscribe, store.getState);
}
